import React from "react";
import { useTranslation } from "react-i18next";
import { FaShareAlt } from "react-icons/fa";

const CopyLinkBoxMobile = ({ eventIdUser, eventTitle }) => {
  const { t } = useTranslation();

  const handleShare = async () => {
    const publicLink = `https://eventbycar.com/event/user/${eventIdUser}`;
    if (navigator.share) {
      try {
        await navigator.share({
          title: `${t("dashboard.share_for_event")} ${eventTitle}`,
          text: `${t("dashboard.share_for_event")} ${eventTitle}`,
          url: publicLink,
        });
      } catch (error) {
        console.error("Erreur de partage :", error);
      }
    } else {
      alert(t("dashboard.share_not_supported"));
    }
  };

  return (
    <div
      onClick={handleShare}
      className="flex items-center mt-2 bg-blue-50 border border-blue-200 p-2 rounded text-xs cursor-pointer hover:bg-blue-100 transition"
    >
      <div className="w-1/5 flex justify-center">
        {navigator.share && (
          <FaShareAlt className="w-7 h-7 text-blue-600" />
        )}
      </div>
      <div className="w-4/5 pl-2">
        <p className="text-gray-700">{t("dashboard.share_tip")}</p>
      </div>
    </div>
  );
};

export default CopyLinkBoxMobile;
